export const CHATGPT_PLUGIN_FLAG = 'BOO-1346-chatgpt-plugin-route'

export const CHATGPT_PLUGIN_URL = 'https://chatgpt.com/plugins/plugin_asdk_app_6ad6d54c4198819198b7f9424f666936'

const CHATGPT_INTEGRATION_ID = 'chatGPT'

const CHATGPT_PLUGIN_COPY = Object.freeze({
  install: 'Install the AhaSlides plugin in ChatGPT',
  description: 'Ask ChatGPT to create and edit your AhaSlides presentations, surveys and courses. Works on any ChatGPT plan, free included.',
  howitworks: [
    'Click Install plugin, then sign in with your AhaSlides account.',
    'Ask ChatGPT for a presentation, then refine it in AhaSlides.',
  ],
  tip: 'Set up AhaSlides in ChatGPT',
  tipDesc: 'Works on any ChatGPT plan, free included.',
})

const toPluginCard = (item) => ({
  ...item,
  desc: CHATGPT_PLUGIN_COPY.description,
  url: CHATGPT_PLUGIN_URL,
})

const toPluginDetail = (item) => ({
  ...item,
  title: CHATGPT_PLUGIN_COPY.install,
  desc: CHATGPT_PLUGIN_COPY.description,
  url: CHATGPT_PLUGIN_URL,
  guides: [],
  howitworks: CHATGPT_PLUGIN_COPY.howitworks,
  tips: [
    {
      text: CHATGPT_PLUGIN_COPY.tip,
      desc: CHATGPT_PLUGIN_COPY.tipDesc,
      link: CHATGPT_PLUGIN_URL,
    },
  ],
})

export const withChatGPTPluginGroups = (groups) => groups.map((group) => ({
  ...group,
  items: group.items.map((item) => (item.id === CHATGPT_INTEGRATION_ID ? toPluginCard(item) : item)),
}))

export const withChatGPTPluginMenu = (menuItems) => menuItems.map(
  (item) => (item.id === CHATGPT_INTEGRATION_ID ? toPluginDetail(item) : item),
)
